<template>
    <div>
        <router-link :to="'/faq-categories/'+row.id+ '/details'"
                     class="btn btn-sm btn-clean btn-icon btn-icon-sm"
        >
            <i class="fa fa-eye"></i>
        </router-link>
    </div>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import {FAQService} from '@/common/api.service'
import toastr from 'toastr'
import {i18n} from "@/plugins/i18n";

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    data() {
        return {
            q: {}
        }
    },
    computed: {
        selector() {
            return $('tr[data-row="'+this.index+'"')
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },
    methods : {
    },
})
</script>